import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import LoginPage from './pages/LoginPage';
import Resumen from './components/Resumen';
import Prospeccion from './components/Prospeccion';
import Personal from './components/Personal';
import './App.css';
import { SummaryProvider } from './components/SummaryContext';
import SupervisorResumen from './components/SupervisorResumen'; // Nuevo componente para supervisores
import UserManagement from './components/UserManagement';
import SupervisorNavbar from './components/SupervisorNavbar'; // Nuevo Navbar para supervisores
import Profile from './components/Profile'; // Nuevo Navbar para supervisores
import Tablero from './components/ClientBoard'; // Nuevo Navbar para supervisores
import AttendanceCalendar from './components/AttendanceCalendar'; // Nuevo Navbar para supervisores
import ErrorBoundary from './components/ErrorBoundary';
import NotFoundPage from './components/NotFoundPage'; // Ajusta la ruta según tu estructura de archivos
import AlumnosList from './components/AlumnosList';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// 1. Crea el cliente de Query (configuración recomendada para producción)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minuto hasta que los datos se consideren obsoletos
      retry: 2, // Reintentar peticiones fallidas 2 veces
      refetchOnWindowFocus: false, // Evita recargas al cambiar de pestaña
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <SummaryProvider>
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
        </SummaryProvider>
        {/* Mover ToastContainer dentro del Router */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Router>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

function AppRoutes() {
      const location = useLocation();
      const token = localStorage.getItem('token');
      const [isSupervisor, setIsSupervisor] = useState(() => localStorage.getItem('isSupervisor') === "true");
      useEffect(() => {
          const checkSupervisorStatus = () => {
              const supervisorStatus = localStorage.getItem('isSupervisor') === "true";
              setIsSupervisor(supervisorStatus);
          };
            checkSupervisorStatus();
      }, [localStorage.getItem('isSupervisor')]);

      const isAuthenticated = !!token;
      // Redirigir sólo si estás exactamente en "/"
      if (location.pathname === '/' && isAuthenticated) {
          return <Navigate to={isSupervisor ? "/supervision/resumen" : "/resumen"} />;
      }
  
      return (
          <>
              {!isSupervisor && location.pathname !== '/' && <Navbar />}
              {isSupervisor && location.pathname.startsWith('/supervision') && <SupervisorNavbar />}
  
              <Routes>
                  <Route path="/" element={<LoginPage />} />
                  
                  {isSupervisor && (
                      <>
                          <Route path="/supervision/resumen" element={<SupervisorResumen />} />
                          <Route path="/supervision/user-management" element={<UserManagement />} />
                          <Route path="/supervision/attendance" element={<AttendanceCalendar />} />
                          <Route path="/supervision/administration" element={<AlumnosList />} />
                          <Route path="*" element={<Navigate to="/supervision/resumen" />} />
                      </>
                  )}
  
                  {!isSupervisor && (
                      <>
                          <Route path="/resumen" element={isAuthenticated ? <Resumen /> : <Navigate to="/" />} />
                          <Route path="/prospeccion" element={isAuthenticated ? <Prospeccion /> : <Navigate to="/" />} />
                          <Route path="/personal" element={isAuthenticated ? <Personal /> : <Navigate to="/" />} />
                          <Route path="/profile" element={isAuthenticated ? <Profile /> : <Navigate to="/" />} />
                          <Route path="/board" element={isAuthenticated ? <Tablero /> : <Navigate to="/" />} />
                          <Route path="*" element={<Navigate to="/resumen" />} />
                      </>
                  )}
              </Routes>
          </>
      );
  }
 

export default App;
